import React from 'react';

import InvoiceLineItemTableRow from './InvoiceLineItemTableRow';

import InvoiceLineItem from '../../Entities/InvoiceLineItem';
import LineItemEntry from '../../Entities/LineItemEntry';

import withInvoice from '../Common/WithInvoice';
import featureFlags from "../../featureFlags";

import './InvoiceLineItemTable.scss';

class InvoiceLineItemTable extends React.Component {
  _onLineItemChange(ident) {
    return value => {
      this.props.onLineItemChange(ident, value);
    };
  }


  handleAddLineItemClick = () => {
    const {
      newMode
    } = this.props;

    const lineItem = new InvoiceLineItem();
    const lineItemEntry = new LineItemEntry();
    if (newMode) lineItemEntry.fields.type.value = 'CHARGE';
    lineItem.fields.entries.value.push(lineItemEntry);

    this._onLineItemChange(null)(lineItem);
  }

  render() {
    const {
      lineItemRows,
      subscription,
      rates,
      inputId,
      newMode,
      adjustmentMode,
      fieldConfiguration,
      allowMetadataEditing,
      invoice,
      lineItemFeeTypes,
      fees,
      updateSelectedFees,
      selectedFees,
    } = this.props;

    const columns = invoice.isValidation ? [
      { value: 'rate-type', label: 'Rate Type' },
      { value: 'product-name', label: 'Product Name' },
      { value: 'quantity', label: 'Quantity' },
      { value: 'amount', label: 'Amount' },
      { value: 'balance', label: 'Balance' }
    ] : featureFlags.CARRYOVER_RATE && invoice.isCarryover ? [
      { value: 'line-item-rate-type', label: 'Rate Type' },
      { value: 'parker-name', label: 'Parker' },
      { value: 'rate-name', label: 'Rate' },
      { value: 'fee-type', label: 'Fee Type' },
      { value: 'selected-date-range', label:'Selected Dates' },
      { value: 'amount', label: 'Amount' },
      { value: 'balance', label: 'Balance' }
    ] : [
      { value: 'fee-type', label: 'Fee' },
      { value: 'parker-name', label: 'Parker' },
      { value: 'rate-name', label: 'Rate' },
      { value: 'selected-date-range', label:'Selected Dates' },
      { value: 'amount', label: 'Amount' },
      { value: 'balance', label: 'Balance' }
    ];

    return (
      <div className="parkchirp--invoice-line-item-table">
        <header className="parkchirp--invoice-line-item-table--header">
          {columns.map((column, i) => {
            return (
              <div key={`${i}`} className={`parkchirp--invoice-line-item-table--${column.value}-column parkchirp--invoice-line-item-table--cell`}>
                <span className="parkchirp--invoice-line-item-table--column-heading">{column.label}</span>
              </div>
            )
          })}
          <div className="parkchirp--invoice-line-item-table--actions-column parkchirp--invoice-line-item-table--cell">
          </div>
        </header>
        <div className="parkchirp--invoice-line-item-table--body">
          {lineItemRows.map(lineItemRow =>
            <InvoiceLineItemTableRow inputId={`${inputId}--${lineItemRow.ident}`}
              key={lineItemRow.ident}
              lineItem={lineItemRow.data}
              subscription={subscription}
              rates={rates}
              fees={fees}
              newMode={newMode}
              adjustmentMode={adjustmentMode}
              onChange={this._onLineItemChange(lineItemRow.ident)}
              fieldConfiguration={fieldConfiguration}
              allowMetadataEditing={allowMetadataEditing}
              lineItemFeeTypes={lineItemFeeTypes}
              id={lineItemRow.ident}
              updateSelectedFees={updateSelectedFees}
              selectedFees={selectedFees}
            />
          )}
          {(newMode) &&
            <div className="parkchirp--invoice-line-item-table-row parkchirp--invoice-line-item-table--cell">
              <button type="button"
                className="parkchirp--button-as-link"
                onClick={this.handleAddLineItemClick}>
                Add Line Item
              </button>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default withInvoice(InvoiceLineItemTable);
